import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import moment from "moment";
import usePermission from "../../customHook/usePermission";

const AdminCommission = () => {
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState({});
  const [pagination, setPagination] = useState(null);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const permission = usePermission();

  const pageRef = useRef(page);

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "Order ID",
        accessor: "order_id",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Food Amount",
        accessor: "food_amount",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || 0}</p>;
        },
      },
      {
        Header: "Tax Amount",
        accessor: "tax_amount",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || 0}</p>;
        },
      },
      {
        Header: "Delivery Amount",
        accessor: "total_delivery_amount",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || 0}</p>;
        },
      },
      {
        Header: "Delivery Partner Amount",
        accessor: "delivery_partner_amount",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || 0}</p>;
        },
      },
      {
        Header: "Admin Amount",
        accessor: "delivery_partner_admin_amount",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || 0}</p>;
        },
      },
    ];

    // let action = {
    //     Header: "Action",
    //     accessor: "action",
    //     disableSortBy: true,
    //     Cell: ({ row }) => {
    //         return (
    //             <>
    //                 {permission?.includes("CAN-VIEW-HELP_AND_SUPPORT") && (
    //                     <button
    //                         className="action-btn"
    //                         onClick={() => handleView(row?.original)}
    //                     >
    //                         <FaEye />
    //                     </button>
    //                 )}
    //             </>
    //         );
    //     },
    // };

    return [...d];
  }, [page, data]);

  const fetch = async () => {
    try {
      let res = await get(
        `${URLS.COMMISSION}?page=${page || 1}&search=${searchText || ""}`,
      );

      if (res?.status === "success") {
        setData(res?.data || []);
        setTotalCount(res || {});
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching help support list:", error);
    }
  };

  useEffect(() => {
    fetch();
  }, [page, searchText]);
  console.log("Notificationdata", data);

  return (
    <>
      <PageHeader title="Admin Commission" />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: 30,
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total trns. : {totalCount?.total_transactions || 0}
        </h2>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total Tax Amount : {totalCount?.total_tax_amount || 0}
        </h2>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total Food Amount : {totalCount?.total_food_amount || 0}
        </h2>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total Delivery Amount : {totalCount?.total_delivery_amount || 0}
        </h2>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total Delivery Partner Amount :{" "}
          {totalCount?.total_delivery_partner_amount || 0}
        </h2>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total Delivery Partner Admin Amount :{" "}
          {totalCount?.total_delivery_partner_admin_amount || 0}
        </h2>
      </div>
      <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </>
  );
};

export default AdminCommission;
